module.exports = __webpack_public_path__ + "img/male3.40ca18a3.jpg";